<template>
  <div class="container">
    <div id="header">
      <div class="flex flex-row-left margin-top-20">
        <div class="flex-item-left">
          <el-form :inline="true" :model="form" class="demo-form-inline">
            <el-form-item label="时间" style="margin-right: 30px">
              <el-date-picker
                  v-model="dateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  :shortcuts="dateShortcuts"
              />
            </el-form-item>
            <el-form-item label="EDI编号：" style="margin-right: 30px">
              <el-input
                  style="width:300px"
                  v-model="form.po"
                  placeholder="请输入EDI编号"
                  clearable
                  @keyup.enter="onSubmit"
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="margin-20-0">
      <div>
        <el-table
            :max-height="dynamicHeight"
            :data="invoiceLineDate"
            :stripe="true"
            :border="true"
            :highlight-current-row="true"
            size="default"
            row-key="id"
            ref="multipleTableRef"
            @selection-change="handleSelectionChange"
            @expand-change="handleExpandChange"
        >
          <el-table-column label="EDI编号" prop="po"/>
          <el-table-column label="创建时间" show-overflow-tooltip prop="addDate" align="center"/>
          <el-table-column label="总税额" show-overflow-tooltip prop="totalCents" align="center"/>
          <el-table-column label="总数量" show-overflow-tooltip prop="totalQuantity" align="center"/>
          <el-table-column label="付款条款" show-overflow-tooltip prop="paymentTerms" align="center"/>
          <el-table-column label="发票截止日期" show-overflow-tooltip prop="paymentDueDate" align="center"/>
          <el-table-column label="纳税申报日期" show-overflow-tooltip prop="taxTime" align="center"/>
          <el-table-column label="货物交付日期" show-overflow-tooltip prop="deliveryDateEndTime" align="center"/>
          <el-table-column label="客户下单日期" show-overflow-tooltip prop="invoiceDate" align="center"/>
          <el-table-column label="仓库发货日期" show-overflow-tooltip prop="paymentDueDate" align="center"/>
          <el-table-column label="操作状态" show-overflow-tooltip prop="state" align="center">
            <template #default="scope">
              <el-tag :type="scope.row.fileStatus==1?'success':scope.row.fileStatus==2?'success':'info'">{{scope.row.fileStatus===1?'已下载':scope.row.fileStatus===2?'已推送':'无操作'}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template #default="scope">
              <el-button
                  link
                  type="primary"
                  size="small"
                  @click="handleSingleDownload(scope.row, 0)"
              >
                预览
              </el-button>
              <el-popconfirm
                  confirm-button-text="确定"
                  cancel-button-text="取消"
                  :icon="InfoFilled"
                  icon-color="#626AEF"
                  title="确定要下载吗?"
                  @confirm="downloadInvoice(scope.row)"
              >
                <template #reference>
                  <el-button link type="primary" size="small" > 下载 </el-button>
                </template>
              </el-popconfirm>
              <el-popconfirm
                  confirm-button-text="确定"
                  cancel-button-text="取消"
                  :icon="InfoFilled"
                  icon-color="#626AEF"
                  title="确定要推送吗?"
                  @confirm="handleSingleDownload(scope.row, 2)"
              >
                <template #reference>
                  <el-button link type="primary" size="small" > 推送 </el-button>
                </template>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="flex flex-row-center flex-item-center margin-10-0">
        <el-pagination
            v-model:current-page="form.page"
            :page-size="form.pageSize"
            :total="total"
            :page-sizes="[10, 20, 30, 50]"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            layout="total, sizes, prev, pager, next,"
        />
      </div>
    </div>
    <EdiPreview v-model="previewVisible" :edi-string="ediText" />
  </div>
</template>

<script>
import {
  ElButton,
  ElDatePicker,
  ElInput,
  ElMessage,
  ElPagination,
  ElTable,
  ElFormItem,
  ElForm,
  ElTableColumn,
} from "element-plus";

import dayjs from "dayjs";
import {
  addFile,
  getAddEdiList,
  getInvoiceLineItems,
  previewEdifact,
  // uplInvoice
} from "@/utils/api";
import dynamicHeightMixin from "@/../public/js/dynamicHeightMixin";
import EdiPreview from "@/components/EdiPreview.vue";
import {
  InfoFilled
} from "@element-plus/icons-vue";

export default {
  name: "IndexEdi",
  computed: {
    InfoFilled() {
      return InfoFilled
    }
  },
  components: {
    ElTable,
    ElTableColumn,
    ElPagination,
    ElButton,
    ElInput,
    ElDatePicker,
    ElFormItem,
    ElForm,
    EdiPreview,
  },
  mixins: [dynamicHeightMixin],
  data() {
    return {
      ediText: "",
      drawer: false,
      previewVisible: false,
      previewData: {},
      selectedOrders: [], // 存储选中的订单对象
      invoiceLineItemsDate: [],
      invoiceLineDate: [],
      dateRange: this.getMonthRange(),
      form: {
        po: "",
        beganData: "",
        endData: "",
        page: 1,
        pageSize: 50,
      },
      total: 0,
      loading: false,
      multipleSelection: [],
      dateShortcuts: [
        {
          text: "最近一周",
          value: () => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            return [start, end];
          },
        },
        {
          text: "最近一个月",
          value: () => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            return [start, end];
          },
        },
        {
          text: "最近三个月",
          value: () => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30 * 3);
            return [start, end];
          },
        },
      ],
    };
  },
  methods: {
    //展开
    handleExpandChange(row) {
      if (row.items != null) {
        return;
      }
      getInvoiceLineItems(row.poNumber)
          .then((res) => {
            if (res.code === "200") {
              row.items = res.data || [];
            } else {
              ElMessage.error(res.msg || "获取数据失败");
            }
          })
          .catch((error) => {
            ElMessage.error("获取数据失败: " + (error.message || "未知错误"));
          });
    },

    //选中
    handleSelectionChange(val) {
      this.multipleSelection = val || [];
    },

    // 单个下载/预览/推送
    handleSingleDownload(row, state) {
      if (!row || !row.po) {
        ElMessage.warning("无效的行数据");
        return;
      }
      this.loading = true;
      previewEdifact(row.isUnique, state)
          .then((res) => {
            if (res.code === "200") {
              this.ediText = res.data || "";
              if (state === 0){
                this.previewVisible = true;
              }
              if (state!==0){
                ElMessage.success("推送成功");
              }
              this.onSubmit()
            } else {
              ElMessage.error(res.msg || "操作失败");
            }
          })
          .catch((error) => {
            console.log(error)
          })
    },
    downloadInvoice(row) {
      addFile(row.isUnique).then(response => {
        // 1. 验证响应
        if (!response || typeof response !== 'object') {
          ElMessage.error('无效的服务器响应');
          return;
        }

        if (response.code === "200") {
          // 2. 安全处理数据
          const fileContent = String(response.data || '');
          const safeFileName = `${row.po.replace(/[\\/:*?"<>|]/g, '_').replace(/\s+/g, '+')}_invoice.txt`
          // 3. 安全下载
          try {
            const blob = new Blob([fileContent], { type: 'text/plain' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = safeFileName;
            link.click();
            setTimeout(() => URL.revokeObjectURL(url), 100);
            ElMessage.success(`文件下载成功: ${safeFileName}`);
            this.onSubmit()
          } catch (error) {
            ElMessage.error('文件创建失败');
          }
        } else {
          ElMessage.error(response.msg || '下载失败');
        }
      }).catch(error => {
        ElMessage.error(`网络请求失败: ${error}`);
      });
    },



    getMonthRange() {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30 * 2);
      end.setTime(end.getTime() + 3600 * 1000 * 24 * 30 * 1);
      return [start, end];
    },

    handleCurrentChange(val) {
      this.form.page = val;
      this.onSubmit();
    },

    handleSizeChange(val) {
      this.form.pageSize = val;
      this.onSubmit();
    },

    onSubmit() {
      this.loading = true;
      this.form.beganData = this.dateRange?.[0]
          ? dayjs(this.dateRange[0]).format("YYYY-MM-DD")
          : "";
      this.form.endData = this.dateRange?.[1]
          ? dayjs(this.dateRange[1]).format("YYYY-MM-DD")
          : "";

      getAddEdiList(this.form)
          .then((res) => {
            if (res.code === "200") {
              this.invoiceLineDate = res.data?.data || [];
              this.form.page = res.data?.currentPage || 1;
              this.form.pageSize = res.data?.pageSize || 50;
              this.total = res.data?.total || 0;
            } else {
              ElMessage.error(res.msg || "获取数据失败");
            }
          })
          .catch((error) => {
            ElMessage.error("获取数据失败: " + (error.message || "未知错误"));
          })
          .finally(() => {
            this.loading = false;
          });
    },
  },
  created() {
    this.onSubmit();
  },
};
</script>

<style>
.container {
  width: 94%;
  margin: 0 auto;
}

::v-deep .container .el-form-item {
  margin-bottom: 0 !important;
  margin: 0 10px;
  --font-size: 14px;
  margin-bottom: 18px;
}

::v-deep .el-button + .el-button {
  margin-left: 0 !important;
}
/* 响应式设计 */
@media (max-width: 1600px) {
  .dialog-container {
    flex-direction: column;
    gap: 20px;
  }

  .dialog-left {
    border-right: none;
    border-bottom: 1px solid #e8e8e8;
    padding-right: 0;
    padding-bottom: 20px;
  }

  .dialog-right {
    padding-left: 0;
  }
}
</style>